import CopilotActions from "~/components/Copilot/blocks/CopilotActions.vue";
import CopilotError from "~/components/Copilot/blocks/CopilotError.vue";
import CopilotMissingFields from "~/components/Copilot/blocks/CopilotMissingFields.vue";
import CopilotRecap from "~/components/Copilot/blocks/CopilotRecap.vue";
import CopilotResources from "~/components/Copilot/blocks/CopilotResources.vue";
import CopilotSteps from "~/components/Copilot/blocks/CopilotSteps.vue";
import { CopilotDataPartEnum } from "~/utils/enums/copilot/chat.enums";
import type { ICopilotBlock } from "~/utils/interfaces/copilot-interfaces";

/**
 * Registry data part → bubble. The backend streams `{ type: "data-<name>", data }`, we render
 * `component` with `data` bound to `prop`. Adding a custom bubble means: a member in
 * `CopilotDataPartEnum`, its payload in `ICopilotDataParts`, and one entry here.
 * `interactive` marks the blocks that take `disabled` and emit `pick`.
 *
 * A plain map rather than a composable: nothing here is reactive, and nothing needs injection.
 */
export const COPILOT_BLOCKS: Record<CopilotDataPartEnum, ICopilotBlock> = {
  [CopilotDataPartEnum.ANALYSIS]: { component: CopilotSteps, prop: "analysis" },
  [CopilotDataPartEnum.RECAP]: { component: CopilotRecap, prop: "recap" },
  [CopilotDataPartEnum.MISSING]: { component: CopilotMissingFields, prop: "missingFields" },
  [CopilotDataPartEnum.ACTIONS]: { component: CopilotActions, prop: "actions", interactive: true },
  [CopilotDataPartEnum.ERROR]: { component: CopilotError, prop: "error" },
  [CopilotDataPartEnum.RESOURCES]: { component: CopilotResources, prop: "resources" },
};

/** Resolves any registered `data-*` part; unknown types render nothing rather than crashing. */
export function copilotBlockOf(partType: string): ICopilotBlock | null {
  const name = partType.replace(/^data-/, "") as CopilotDataPartEnum;

  // Own keys only: `data-constructor` would otherwise resolve to the inherited member, which is
  // truthy, so `?? null` never fires and the caller gets a block with no component.
  return Object.hasOwn(COPILOT_BLOCKS, name) ? COPILOT_BLOCKS[name] : null;
}
